/* =============================================================
   ISD product page script (blocks/isd-product.liquid)
   - gallery thumbnails
   - real Shopify variant selection (never adds a wrong variant)
   - AJAX add to cart through window.ISD.cart (opens the header drawer)
   - delivery estimate, per-variant content ([data-isd-for])
   - sticky mobile buy bar
   - add-on product gate + box add-on catalogue (special prices need a box in the cart)
   - "Papildomai siūlome" carousel: native scroll-snap + arrow buttons
   - "Kas įeina į dėžutę?": live Shopify bundle composition from the Storefront API as text-only rows that open in place
   ============================================================= */
(function () {
  'use strict';
  /* The script tag can be evaluated again (Theme Editor re-renders): bind the document-level listeners only once. */
  if (window.__isdPdpBound) return;
  window.__isdPdpBound = true;

  var TEXT = Object.assign({ adding: 'Pridedama…', added: 'Pridėta', error: 'Nepavyko pridėti. Bandykite dar kartą.', more: 'Rodyti daugiau', loading: 'Kraunama…', empty: 'Šioje kategorijoje produktų nėra.', add: 'Pridėti', soldout: 'Išparduota', from: 'Nuo ', locked: 'Prieinama su dėžute', chooseVariant: 'Pasirinkite variantą.', unavailable: 'Šis derinys negalimas', loadFail: 'Nepavyko įkelti produktų. Atnaujinkite puslapį.', compSize: 'Svoris / tūris', compAvail: 'Prieinamumas', compIn: 'Turime sandėlyje', compOut: 'Šiuo metu nėra', compOpen: 'Atidaryti produkto puslapį', compIng: 'Sudėtis', compAllergens: 'Alergenai' }, (window.ISD && window.ISD.ui) || {});

  function money(cents) { return window.ISD ? window.ISD.money(cents) : (cents / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function handleize(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function imgUrl(src, width) { if (!src) return ''; return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + width + 'x$1$2'); }
  function reducedMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  var CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1 13H5L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';
  var LOCK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  /* ---------- Card renderer for the add-on catalogue (same markup as the shared .isd-card) ---------- */
  function cardHtml(p, opts) {
    opts = opts || {};
    var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
    var all = p.variants || [];
    var first = variants[0] || all[0];
    var price = first ? Number(first.price) : (p.price_min != null ? Number(p.price_min) : 0);
    var compare = (!opts.noCompare && first && first.compare_at_price) ? Number(first.compare_at_price) : 0;
    var image = p.featured_image || '';
    var url = p.url || ('/products/' + p.handle);
    var available = p.available !== false && variants.length > 0;
    var badges = '';
    if (compare > price) badges += '<span class="isd-badge isd-badge--sale">-' + Math.round((compare - price) / compare * 100) + '%</span>';
    if (!available) badges += '<span class="isd-badge isd-badge--soldout">' + TEXT.soldout + '</span>';
    var selectId = 'isd-sel-' + p.id + '-' + Math.random().toString(36).slice(2, 7);
    var openAttr = ' data-isd-open="' + (opts.openCart ? 'true' : 'false') + '"';
    var addLabel = opts.addLabel || TEXT.add;
    var action, variantSelect = '';
    if (!available) {
      action = '<button type="button" class="isd-card__add" disabled><span class="isd-card__add-label">' + TEXT.soldout + '</span></button>';
    } else if (opts.locked) {
      action = '<span class="isd-card__add isd-card__add--locked" aria-hidden="true">' + LOCK_ICON + '<span class="isd-card__add-label">' + esc(opts.lockedLabel || TEXT.locked) + '</span></span>';
    } else if (all.length === 1) {
      action = '<button type="button" class="isd-card__add" data-isd-add="' + first.id + '" data-label-default="' + esc(addLabel) + '"' + openAttr + ' aria-label="' + esc(addLabel) + ': ' + esc(p.title) + '">' + CART_ICON + '<span class="isd-card__add-label">' + esc(addLabel) + '</span></button>';
    } else {
      variantSelect = '<div class="isd-pdp__variant-select"><select id="' + selectId + '" aria-label="' + esc(String(TEXT.chooseVariant).replace(/[.\s]+$/, '')) + '">' + all.map(function (v) { return '<option value="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' + esc(v.title) + (v.available === false ? ' — ' + TEXT.soldout.toLowerCase() : '') + '</option>'; }).join('') + '</select></div>';
      action = '<button type="button" class="isd-card__add" data-isd-add="' + first.id + '" data-isd-select="' + selectId + '" data-label-default="' + esc(addLabel) + '"' + openAttr + ' aria-label="' + esc(addLabel) + ': ' + esc(p.title) + '">' + CART_ICON + '<span class="isd-card__add-label">' + esc(addLabel) + '</span></button>';
    }
    var tag = opts.priceTag ? '<span class="isd-card__tag">' + esc(opts.priceTag) + '</span>' : '';
    var sr = opts.locked && available ? '<span class="isd-visually-hidden"> — ' + esc(opts.lockedLabel || TEXT.locked) + '</span>' : '';
    return '<article class="isd-card' + (opts.locked ? ' isd-card--locked' : '') + '" data-isd-card data-product-id="' + p.id + '">'
      + '<div class="isd-card__media">' + (image ? '<img class="isd-card__img isd-card__img--first" src="' + esc(imgUrl(image, 480)) + '" alt="' + esc(p.title) + '" width="480" height="480" loading="lazy">' : '') + (badges ? '<div class="isd-card__badges">' + badges + '</div>' : '') + action + '</div>'
      + '<div class="isd-card__body"><a class="isd-card__title" href="' + esc(url) + '">' + esc(p.title) + sr + '</a><div class="isd-card__price' + (compare > price ? ' isd-card__price--sale' : '') + '"><span class="isd-card__price-now">' + (p.price_varies && !variantSelect ? TEXT.from : '') + money(price) + '</span>' + (compare > price ? '<s>' + money(compare) + '</s>' : '') + tag + '</div>' + variantSelect + '</div>'
      + '<a class="isd-card__link" href="' + esc(url) + '" tabindex="-1" aria-hidden="true"></a>'
      + '</article>';
  }

  /* products.json gives decimal strings; normalise to cents */
  function normalizeProduct(p) {
    var cents = function (v) { return v == null ? 0 : Math.round(parseFloat(v) * 100); };
    return {
      id: p.id, title: p.title, handle: p.handle, url: p.url || ('/products/' + p.handle),
      tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); }),
      type: p.product_type || p.type || '',
      available: p.available !== undefined ? p.available : (p.variants || []).some(function (v) { return v.available; }),
      featured_image: p.featured_image || (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : ''),
      price_min: (function () { var vs = (p.variants || []); var ok = vs.filter(function (v) { return v.available !== false; }); var list = ok.length ? ok : vs; return list.length ? Math.min.apply(null, list.map(function (v) { return cents(v.price); })) : 0; })(),
      price_varies: (p.variants || []).length > 1 && (p.variants || []).some(function (v) { return v.price !== p.variants[0].price; }),
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available !== false, price: cents(v.price), compare_at_price: v.compare_at_price ? cents(v.compare_at_price) : 0 }; })
    };
  }

  /* ---------- Delivery estimate: business days only (Mon-Fri), optional cutoff hour ---------- */
  var MONTHS_LT = ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'];
  function addBusinessDays(date, n) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function nextBusinessStart(now, cutoff) {
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var w = d.getDay();
    var late = cutoff > 0 && now.getHours() >= cutoff;
    if (w === 0 || w === 6 || late) d = addBusinessDays(d, 1);
    return d;
  }
  function fmtLt(d) { return MONTHS_LT[d.getMonth()] + ' ' + d.getDate() + ' d.'; }
  function fmtRange(a, b) {
    if (a.getTime() === b.getTime()) return fmtLt(a);
    if (a.getMonth() === b.getMonth()) return MONTHS_LT[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() + ' d.';
    return fmtLt(a) + ' – ' + fmtLt(b);
  }
  function initDelivery(el) {
    var now = new Date();
    var start = nextBusinessStart(now, Number(el.getAttribute('data-cutoff') || 0));
    var ship = addBusinessDays(start, Number(el.getAttribute('data-processing') || 0));
    var from = addBusinessDays(ship, Number(el.getAttribute('data-ship-min') || 1));
    var to = addBusinessDays(ship, Math.max(Number(el.getAttribute('data-ship-min') || 1), Number(el.getAttribute('data-ship-max') || 1)));
    var shipEl = el.querySelector('[data-isd-delivery-ship]');
    var arriveEl = el.querySelector('[data-isd-delivery-arrive]');
    var shipText = (el.getAttribute('data-ship-text') || '').replace('{ship}', fmtLt(ship));
    var arriveText = (el.getAttribute('data-arrive-text') || '').replace('{range}', fmtRange(from, to)).replace('{from}', fmtLt(from)).replace('{to}', fmtLt(to));
    if (shipEl) shipEl.textContent = shipText;
    if (arriveEl) { arriveEl.textContent = arriveText; arriveEl.hidden = !arriveText; }
    el.hidden = !shipText && !arriveText;
  }

  /* ---------- Box eligibility from the shared cart state ---------- */
  function onBoxState(owner, fn) {
    if (window.ISD && window.ISD.state) {
      var off = window.ISD.state.subscribe(function (st) { if (!owner.isConnected) { if (off) off(); return; } fn(!!st.hasBox, st); });
      return;
    }
    var onState = function (e) { if (!owner.isConnected) { document.removeEventListener('isd:state', onState); return; } fn(!!e.detail.state.hasBox, e.detail.state); };
    document.addEventListener('isd:state', onState);
  }

  /* ---------- "Kas įeina į dėžutę?": the live Shopify bundle composition ----------
     Liquid does not expose bundle components, the Storefront API does (tokenless access; components that are still drafts are included,
     but their metafields and stock levels are not readable). One small read-only request per box page. Each component becomes a text-only
     row (quantity and title) that opens in place: the real description, size, availability and, for ACTIVE components, the ingredients and
     allergens read once from the alternate product view /products/<handle>?view=isd-info (templates/product.isd-info.liquid) when the row is first
     opened. Draft components never get a link. Any problem (offline, API change, no bundle) leaves the section hidden, or shows the
     rich-text fallback from the block settings. */
  var SF_ENDPOINT = '/api/2026-01/graphql.json';
  var SF_FIELDS = '{product(handle:$handle){variants(first:30){nodes{id requiresComponents components(first:50){nodes{quantity productVariant{title availableForSale product{title handle description onlineStoreUrl}}}}}}}}';
  function storefront(query, vars) {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 6000) : 0;
    return fetch(SF_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ query: query, variables: vars }), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .finally(function () { clearTimeout(timer); });
  }
  function fetchBundle(handle, lang) {
    function pick(j) { return j && !j.errors && j.data && j.data.product ? j.data.product : null; }
    var plain = function () { return storefront('query($handle:String!)' + SF_FIELDS, { handle: handle }).then(pick); };
    if (!/^[A-Z]{2}$/.test(lang)) return plain();
    /* titles in the shopper's language (the same translations the rest of the page uses); unsupported language -> unlocalised */
    return storefront('query($handle:String!,$lang:LanguageCode)@inContext(language:$lang)' + SF_FIELDS, { handle: handle, lang: lang }).then(pick).then(function (p) { return p || plain(); }, plain);
  }
  /* what the row shows: the supplier description without the weight sentence and the lot-specific best-before sentence; the size comes from that
     "Svoris: ..." sentence or from the title ("... 180 g"). The variant weight is a SHIPPING weight (a 1 l oil weighs 1.5 kg), so it is never shown. */
  var SIZE_RE = /(\d+(?:[.,]\d+)?)\s?(kg|g|ml|l|cl)(?![a-zA-ZĄ-ž])/i;
  function compInfo(pr) {
    var d = String(pr.description || '').replace(/\s+/g, ' ').trim();
    var size = '';
    var m = d.match(/(?:Svoris|Tūris|Grynas svoris|Nusausintas svoris)\s*:\s*([^.]*\d[^.]*)\.?/i);
    if (m) { size = m[1].trim(); d = d.replace(m[0], ' '); }
    d = d.replace(/Geriaus\S*\s+iki[^.]*\.?/gi, ' ').replace(/\s+/g, ' ').trim();
    if (!size) { var t = String(pr.title || '').match(SIZE_RE); if (t) size = t[1] + ' ' + t[2].toLowerCase(); }
    if (d.length > 420) { var cut = d.lastIndexOf('. ', 420); d = cut > 120 ? d.slice(0, cut + 1) : d.slice(0, 420).trim() + '…'; }
    return { text: d, size: size };
  }
  function compRowHtml(c) {
    var pv = c.productVariant || {}, pr = pv.product || {};
    var name = pr.title || '';
    if (!name) return '';
    if (pv.title && pv.title !== 'Default Title') name += ' · ' + pv.title;
    var qty = Number(c.quantity) || 1;
    var info = compInfo(pr);
    var avail = pv.availableForSale !== false;
    var live = !!pr.onlineStoreUrl && !!pr.handle;
    var facts = '';
    if (info.size) facts += '<dt>' + esc(TEXT.compSize) + '</dt><dd>' + esc(info.size) + '</dd>';
    facts += '<dt>' + esc(TEXT.compAvail) + '</dt><dd><span class="isd-pdp__comp-dot' + (avail ? '' : ' is-out') + '" aria-hidden="true"></span>' + esc(avail ? TEXT.compIn : TEXT.compOut) + '</dd>';
    return '<li class="isd-pdp__incl-item"><details class="isd-pdp__comp"' + (live ? ' data-handle="' + esc(pr.handle) + '"' : '') + '>'
      + '<summary><span class="isd-pdp__incl-qty">' + qty + '×</span><span class="isd-pdp__incl-name">' + esc(name) + '</span><span class="isd-pdp__acc-ico" aria-hidden="true"></span></summary>'
      + '<div class="isd-pdp__comp-body">' + (info.text ? '<p>' + esc(info.text) + '</p>' : '')
      + '<dl class="isd-pdp__comp-facts" data-isd-comp-facts>' + facts + '</dl>'
      + (live ? '<p><a class="isd-pdp__comp-link" href="/products/' + encodeURIComponent(pr.handle) + '">' + esc(TEXT.compOpen) + '</a></p>' : '')
      + '</div></details></li>';
  }
  function compListHtml(comps, visible, showAll) {
    var items = comps.map(compRowHtml).filter(Boolean);
    if (!items.length) return '';
    var html = '<ul class="isd-pdp__incl-list">' + items.slice(0, visible).join('') + '</ul>';
    if (items.length > visible) html += '<details class="isd-pdp__incl-more"><summary><span>' + esc(showAll) + ' (' + items.length + ')</span><svg viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 1l5 5 5-5"/></svg></summary><ul class="isd-pdp__incl-list">' + items.slice(visible).join('') + '</ul></details>';
    return html;
  }
  function htmlText(html) {
    var t = document.createElement('template');
    t.innerHTML = html;
    return (t.content.textContent || '').replace(/\s+/g, ' ').trim();
  }
  /* first opening of a row of an ACTIVE component: ingredients and allergens from the alternate product view (the product's own metafields) */
  function loadCompMore(d, handle) {
    var facts = d.querySelector('[data-isd-comp-facts]');
    if (!facts || !window.fetch) return;
    fetch('/products/' + encodeURIComponent(handle) + '?view=isd-info', { headers: { Accept: 'text/plain, */*' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (t) {
        var j = JSON.parse(t);
        var ing = htmlText(j.ingredients_html || '');
        var k = ing.search(/Maistinė vertė/i);
        var nutrition = k >= 0 ? ing.slice(k).trim() : '';
        if (k >= 0) ing = ing.slice(0, k).trim();
        ing = ing.replace(/^Sudėtis\s*:\s*/i, '').trim();
        var al = Array.isArray(j.allergens) ? j.allergens.filter(Boolean).join(', ') : '';
        var html = '';
        if (ing) html += '<dt>' + esc(TEXT.compIng) + '</dt><dd>' + esc(ing) + '</dd>';
        if (al) html += '<dt>' + esc(TEXT.compAllergens) + '</dt><dd>' + esc(al) + '</dd>';
        if (nutrition) html += '<dt>Maistinė vertė</dt><dd>' + esc(nutrition) + '</dd>';
        if (html) facts.insertAdjacentHTML('beforeend', html);
        d.setAttribute('data-more', 'done');
      })
      .catch(function () { d.setAttribute('data-more', 'failed'); });
  }
  function initLiveIncl(sec, root) {
    var handle = sec.getAttribute('data-handle');
    var visible = Math.max(1, Number(sec.getAttribute('data-visible')) || 6);
    var showAll = sec.getAttribute('data-show-all') || 'Rodyti visą sudėtį';
    var lang = String(document.documentElement.lang || '').slice(0, 2).toUpperCase();
    function finish(state) { if (sec.isConnected) sec.setAttribute('data-state', state); }
    if (!handle || !window.fetch) { finish('fallback'); return; }
    var variantInput = root.querySelector('[data-isd-variant-id]');
    sec.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.classList || !d.classList.contains('isd-pdp__comp') || !d.open || d.hasAttribute('data-more')) return;
      var h = d.getAttribute('data-handle');
      if (!h) return;
      d.setAttribute('data-more', 'loading');
      loadCompMore(d, h);
    }, true);
    fetchBundle(handle, lang).then(function (product) {
      if (!sec.isConnected) return;
      var nodes = product && product.variants && product.variants.nodes ? product.variants.nodes : [];
      var any = false;
      nodes.forEach(function (v) {
        var comps = v.requiresComponents && v.components && v.components.nodes ? v.components.nodes : [];
        var html = compListHtml(comps, visible, showAll);
        if (!html) return;
        var vid = String(v.id).split('/').pop();
        var set = sec.querySelector('.isd-pdp__incl-set[data-isd-for="' + vid + '"]');
        if (!set) {
          set = document.createElement('div');
          set.className = 'isd-pdp__incl-set';
          set.setAttribute('data-isd-for', vid);
          set.hidden = !!variantInput && String(variantInput.value) !== vid;
          sec.appendChild(set);
        }
        set.insertAdjacentHTML('beforeend', html);
        set.setAttribute('data-source', 'bundle');
        any = true;
      });
      if (any) {
        sec.querySelectorAll('[data-isd-incl-rich]').forEach(function (n) { n.remove(); });
        sec.hidden = false;
        finish('live');
      } else finish('fallback');
    }).catch(function () { finish('fallback'); });
  }

  /* ---------- Per-page init ---------- */
  function initProduct(root) {
    if (root.dataset.isdReady === '1') return;
    root.dataset.isdReady = '1';

    var jsonEl = root.querySelector('[data-isd-product-json]');
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { product = null; }
    var buy = root.querySelector('[data-isd-buy]');
    var form = root.querySelector('[data-isd-form]');
    var variantInput = root.querySelector('[data-isd-variant-id]');
    var qtyInput = root.querySelector('[data-isd-qty-input]');
    var atc = root.querySelector('[data-isd-atc]');
    var atcLabel = root.querySelector('[data-isd-atc-label]');
    var cta = root.querySelector('[data-isd-cta]');
    var errorEl = root.querySelector('[data-isd-error]');
    var priceNow = root.querySelector('[data-isd-price-now]');
    var priceOld = root.querySelector('[data-isd-price-old]');
    var priceCompare = root.querySelector('[data-isd-price-compare]');
    var priceBadge = root.querySelector('[data-isd-price-badge]');
    var stock = root.querySelector('[data-isd-stock]');
    var stockReady = root.querySelector('[data-isd-stock-ready]');
    var sticky = root.querySelector('[data-isd-sticky]');
    var delivery = root.querySelector('[data-isd-delivery]');
    var gate = root.querySelector('[data-isd-gate]');
    var isAddon = root.getAttribute('data-mode') === 'addon';
    if (delivery) initDelivery(delivery);

    /* Gallery */
    var gallery = root.querySelector('[data-isd-gallery]');
    function showSlide(i) {
      if (!gallery) return;
      gallery.querySelectorAll('[data-isd-slide]').forEach(function (s) { s.setAttribute('data-active', s.getAttribute('data-isd-slide') === String(i) ? 'true' : 'false'); });
      gallery.querySelectorAll('[data-isd-thumb]').forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-isd-thumb') === String(i) ? 'true' : 'false'); });
    }
    if (gallery) gallery.addEventListener('click', function (e) { var t = e.target.closest('[data-isd-thumb]'); if (t) showSlide(t.getAttribute('data-isd-thumb')); });
    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var s = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (s) showSlide(s.getAttribute('data-isd-slide'));
    }

    /* Screen-reader status (variant changes, added to cart); the element is server-rendered so the live region exists before it changes */
    var statusEl = root.querySelector('[data-isd-status]');
    var statusTimer = 0;
    function announce(msg) {
      if (!statusEl) return;
      statusEl.textContent = '';
      clearTimeout(statusTimer);
      statusTimer = setTimeout(function () { statusEl.textContent = msg; }, 40);
    }

    /* Button label / "added" state: one timer, cancelled by anything that changes the button */
    var resetTimer = 0;
    function clearReset() { if (resetTimer) { clearTimeout(resetTimer); resetTimer = 0; } if (cta) cta.classList.remove('is-added'); }
    function restoreLabel() { if (atc && atcLabel) atcLabel.textContent = atc.disabled ? atc.getAttribute('data-label-soldout') : atc.getAttribute('data-label-default'); }
    function hideError() { if (errorEl) errorEl.hidden = true; }

    /* Variants */
    var selected = [];
    root.querySelectorAll('[data-isd-option-value]').forEach(function (el) { selected[Number(el.getAttribute('data-isd-option-value'))] = el.textContent; });
    function findVariant() {
      if (!product) return null;
      if (!selected.length) return product.variants[0];
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return selected[i] === undefined || o === selected[i]; }); }) || null;
    }
    /* Mark option values that have no purchasable variant (also run once on load, not only after a click) */
    function markOptions() {
      if (!product) return;
      root.querySelectorAll('[data-isd-option]').forEach(function (pill) {
        var idx = Number(pill.getAttribute('data-isd-option'));
        var test = selected.slice(); test[idx] = pill.getAttribute('data-value');
        var exists = product.variants.some(function (pv) { return pv.available && pv.options.every(function (o, i) { return i > idx ? true : o === test[i]; }); });
        pill.classList.toggle('is-unavailable', !exists);
      });
    }
    function applyVariant(v) {
      var available = !!(v && v.available);
      clearReset(); hideError();
      if (variantInput) variantInput.value = v ? v.id : '';
      if (priceNow && v) priceNow.textContent = money(v.price);
      var onSale = !!(v && v.compare_at_price > v.price && !isAddon);
      if (priceOld) priceOld.hidden = !onSale;
      if (priceBadge) priceBadge.hidden = !onSale;
      if (onSale) {
        if (priceCompare) {
          var tn = priceCompare.lastChild;
          if (tn && tn.nodeType === 3) tn.textContent = money(v.compare_at_price); else priceCompare.appendChild(document.createTextNode(money(v.compare_at_price)));
        }
        if (priceBadge) priceBadge.textContent = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% ' + (priceBadge.getAttribute('data-label') || '');
      }
      var inInventory = !!(available && v && v.inventory_management && Number(v.inventory_quantity) > 0);
      if (stock) {
        stock.classList.toggle('is-out', !available);
        stock.classList.toggle('is-order', available && !inInventory);
        stock.textContent = inInventory ? stock.getAttribute('data-in') : (available ? stock.getAttribute('data-order') : (v ? stock.getAttribute('data-out') : TEXT.unavailable));
      }
      if (stockReady) stockReady.hidden = !inInventory;
      if (atc) { atc.disabled = !available; restoreLabel(); }
      if (cta) cta.classList.toggle('is-disabled', !available);
      /* copy that promises "order now" / a ship-by date only makes sense while the variant can be bought */
      root.querySelectorAll('[data-isd-when-available]').forEach(function (el) { el.hidden = !available; });
      root.querySelectorAll('[data-isd-for]').forEach(function (el) { el.hidden = !v || el.getAttribute('data-isd-for') !== String(v.id); });
      if (v && v.featured_media) showMedia(v.featured_media.id);
      if (sticky && v) { var sp = sticky.querySelector('[data-isd-sticky-price]'); if (sp) sp.textContent = money(v.price); var sb = sticky.querySelector('[data-isd-sticky-atc]'); if (sb) sb.disabled = !available; }
      if (v && window.history && window.history.replaceState) { try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString()); } catch (e) { /* ignore */ } }
      markOptions();
      announce(v ? ((v.title && v.title !== 'Default Title' && v.title.replace(/\D/g, '') !== money(v.price).replace(/\D/g, '') ? v.title + ', ' : '') + money(v.price) + ', ' + (available ? (stock && stock.getAttribute('data-in')) || '' : (stock && stock.getAttribute('data-out')) || '')) : TEXT.unavailable);
      if (v) document.dispatchEvent(new CustomEvent('isd:variant-change', { detail: { variant: v } }));
    }
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-isd-option]');
      if (!pill) return;
      var idx = Number(pill.getAttribute('data-isd-option'));
      selected[idx] = pill.getAttribute('data-value');
      root.querySelectorAll('[data-isd-option="' + idx + '"]').forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
      var label = root.querySelector('[data-isd-option-value="' + idx + '"]'); if (label) label.textContent = selected[idx];
      applyVariant(findVariant());
    });
    markOptions();

    /* Quantity */
    function clampQty() { if (!qtyInput || qtyInput.type === 'hidden') return; qtyInput.value = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1)); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-isd-qty]');
      if (!b || !qtyInput) return;
      qtyInput.value = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + Number(b.getAttribute('data-isd-qty'))));
      hideError();
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { clampQty(); hideError(); });

    /* Add-on product page: purchase form only with a box in the real cart */
    var unlocked = !gate;
    if (gate) {
      var lockedEl = gate.querySelector('[data-isd-gate-locked]');
      var openEl = gate.querySelector('[data-isd-gate-open]');
      var stickyLink = sticky ? sticky.querySelector('[data-isd-sticky-boxes]') : null;
      var stickyBtnEl = sticky ? sticky.querySelector('[data-isd-sticky-atc]') : null;
      onBoxState(root, function (hasBox) {
        unlocked = hasBox;
        gate.setAttribute('data-state', hasBox ? 'open' : 'locked');
        if (lockedEl) lockedEl.hidden = hasBox;
        if (openEl) openEl.hidden = !hasBox;
        if (stickyLink) stickyLink.hidden = hasBox;
        if (stickyBtnEl) stickyBtnEl.hidden = !hasBox;
      });
    }

    /* Add to cart (real Shopify cart; header drawer opens afterwards).
       `reveal` (sticky bar only): bring the form into view when the add cannot go through, so the message is seen. */
    function showError(msg, reveal) {
      if (!errorEl) return;
      errorEl.textContent = msg; errorEl.hidden = false;
      if (reveal && form && form.scrollIntoView) form.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
    }
    /* The Kaching Bundles widget writes its selected offer into this form as a hidden input (properties[__kaching_bundles]).
       The cart request carries it, exactly like a native form post: otherwise only the form's own add button (which the app
       hooks) would arm the offer, and the sticky bar's add (a different button) would add the bare product. */
    function lineProps() {
      var out = null;
      if (!form) return out;
      [].forEach.call(form.querySelectorAll('input[name^="properties["]'), function (el) {
        var m = /^properties\[(.+)\]$/.exec(el.name);
        if (m && el.value) { out = out || {}; out[m[1]] = el.value; }
      });
      return out;
    }
    function submit(reveal) {
      if (!atc || atc.disabled || atc.classList.contains('is-loading')) return;
      if (!window.ISD || !window.ISD.cart) { if (form) { form.removeAttribute('data-isd-native'); form.submit(); } return; }
      if (!unlocked) { showError(window.ISD.state ? window.ISD.state.text.addonBlocked : TEXT.locked, reveal); return; }
      var id = variantInput ? variantInput.value : null;
      if (!id) { showError(TEXT.chooseVariant, reveal); return; }
      clampQty();
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      clearReset(); hideError();
      atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true'); if (atcLabel) atcLabel.textContent = TEXT.adding;
      var line = { id: Number(id), quantity: qty }, lp = lineProps();
      if (lp) line.properties = lp;
      window.ISD.cart.add({ items: [line] }).then(function () {
        atc.classList.remove('is-loading'); if (cta) cta.classList.add('is-added'); if (atcLabel) atcLabel.textContent = TEXT.added;
        var addedV = product && product.variants.length > 1 ? product.variants.filter(function (x) { return String(x.id) === String(id); })[0] : null;
        announce(TEXT.added + (product && product.title ? ': ' + product.title : '') + (addedV && addedV.title && addedV.title !== 'Default Title' ? ' (' + addedV.title + ')' : ''));
        if (root.getAttribute('data-open-cart') !== 'false') window.ISD.cart.open();
        /* restore from the CURRENT state (the variant may have been switched to a sold-out one meanwhile) */
        resetTimer = setTimeout(function () { resetTimer = 0; if (cta) cta.classList.remove('is-added'); restoreLabel(); }, 1600);
      }).catch(function (err) {
        atc.classList.remove('is-loading'); restoreLabel();
        showError(err && err.status === 422 && err.message ? err.message : TEXT.error, reveal);
      }).finally(function () { atc.removeAttribute('aria-busy'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-isd-sticky-atc]');
      /* add straight from the sticky bar: the page does not jump; the form is only revealed when something needs the shopper's attention */
      if (stickyBtn) stickyBtn.addEventListener('click', function () { submit(true); });
      /* observe what is actually rendered: the gate on add-on pages (the buy form inside it is display:none while locked), else the buy row */
      var watch = gate || cta;
      if (watch && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { var last = en[en.length - 1]; sticky.classList.toggle('is-visible', !last.isIntersecting && last.boundingClientRect.top < 0); }, { threshold: 0 }).observe(watch);
    }

    /* Carousel + box add-on catalogue */
    root.querySelectorAll('[data-isd-pair-carousel]').forEach(initPairCarousel);
    root.querySelectorAll('[data-pdp-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-isd-box-addons]').forEach(function (el) { initBoxAddons(el); });
    root.querySelectorAll('[data-isd-live-incl]').forEach(function (sec) { initLiveIncl(sec, root); });
  }

  /* Native, keyboard-accessible complimentary product carousel. */
  function initPairCarousel(sec) {
    var track=sec.querySelector('[data-isd-pair-track]'),prev=sec.querySelector('[data-isd-pair-prev]'),next=sec.querySelector('[data-isd-pair-next]'),controls=sec.querySelector('.isd-pdp__pair-controls');
    if(!track||!prev||!next)return;
    function sync(){var over=track.scrollWidth-track.clientWidth>5;if(controls)controls.hidden=!over;prev.disabled=!over||track.scrollLeft<4;next.disabled=!over||track.scrollLeft>=track.scrollWidth-track.clientWidth-4;}
    function go(d){var item=track.querySelector('.isd-pdp__pair-row');var dist=item?item.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0):track.clientWidth;track.scrollBy({left:d*dist,behavior:reducedMotion()?'auto':'smooth'});}
    prev.addEventListener('click',function(){go(-1);});next.addEventListener('click',function(){go(1);});
    track.addEventListener('scroll',sync,{passive:true});
    track.addEventListener('keydown',function(e){if(e.target!==track||e.altKey||e.metaKey||e.ctrlKey)return;if(e.key==='ArrowRight'){e.preventDefault();go(1);}if(e.key==='ArrowLeft'){e.preventDefault();go(-1);}});
    if('ResizeObserver'in window)new ResizeObserver(sync).observe(track);
    track.querySelectorAll('img').forEach(function(img){if(!img.complete)img.addEventListener('load',sync,{once:true});});
    sync();
  }

  /* ---------- "Papildomai siūlome": native scroll-snap row, arrows scroll one card ---------- */
  function initCarousel(sec) {
    var track = sec.querySelector('[data-pdp-track]');
    var wrap = sec.querySelector('[data-pdp-wrap]');
    var prev = sec.querySelector('[data-pdp-prev]');
    var next = sec.querySelector('[data-pdp-next]');
    var arrows = sec.querySelector('.isd-pdp__arrows');
    if (!track || !wrap || !prev || !next) return;
    var ticking = false;

    function step() {
      var card = track.querySelector('[data-isd-pdp-card]');
      if (!card) return Math.round(track.clientWidth * 0.8);
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 4;
      var x = track.scrollLeft;
      var atStart = x <= 2;
      var atEnd = x >= max - 2;
      wrap.classList.toggle('is-start', atStart);
      wrap.classList.toggle('is-end', atEnd);
      wrap.classList.toggle('is-static', !overflow);
      if (arrows) arrows.hidden = !overflow;
      /* aria-disabled (not [disabled]) so a focused arrow keeps focus when it reaches its end */
      prev.setAttribute('aria-disabled', !overflow || atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', !overflow || atEnd ? 'true' : 'false');
    }
    function queue() { if (!ticking) { ticking = true; setTimeout(update, 40); } }
    /* Timer-driven easing (not native smooth scroll): identical in every browser, honours reduced motion,
       and keeps the arrows' disabled state exact. Snap is switched off while it runs, then restored. */
    var animTimer = 0;
    function stopAnim() { clearTimeout(animTimer); animTimer = 0; track.style.scrollSnapType = ''; }
    function animateTo(target) {
      var from = track.scrollLeft, dist = target - from;
      stopAnim();
      if (Math.abs(dist) < 1) { update(); return; }
      if (reducedMotion()) { track.scrollLeft = target; update(); return; }
      var dur = Math.min(560, 260 + Math.abs(dist) * 0.4), t0 = Date.now();
      track.style.scrollSnapType = 'none';
      (function tick() {
        var t = Math.min(1, (Date.now() - t0) / dur), e = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + dist * e;
        if (t < 1) { animTimer = setTimeout(tick, 16); }
        else { animTimer = 0; track.style.scrollSnapType = ''; track.scrollLeft = target; update(); }
      })();
    }
    function go(dir) {
      var s = step(), max = track.scrollWidth - track.clientWidth;
      animateTo(Math.max(0, Math.min(max, (Math.round(track.scrollLeft / s) + dir) * s)));
    }
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) { track.addEventListener(ev, stopAnim, { passive: true }); });

    prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') go(-1); });
    next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') go(1); });
    track.addEventListener('scroll', queue, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.altKey || e.metaKey || e.ctrlKey || e.shiftKey || window.matchMedia('(max-width: 699px)').matches) return; /* native keyboard navigation for mobile grid */
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    /* window listeners are removed once the section is gone (Theme Editor re-renders) */
    var ro = null;
    function onResize() { if (!sec.isConnected) { detach(); return; } queue(); }
    function onLoad() { if (!sec.isConnected) { detach(); return; } update(); }
    function detach() { window.removeEventListener('resize', onResize); window.removeEventListener('load', onLoad); if (ro) ro.disconnect(); }
    window.addEventListener('resize', onResize);
    if ('ResizeObserver' in window) { ro = new ResizeObserver(queue); ro.observe(track); }
    track.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', queue, { once: true }); });
    update();
    /* the first layout may happen before fonts/images settle: re-measure shortly after */
    setTimeout(update, 400);
    window.addEventListener('load', onLoad);

    /* quick-add result for assistive tech: the card buttons only change class (assets/isd-quick-add.js), so mirror it into a live region */
    var live = sec.querySelector('[data-pdp-live]');
    if (live && 'MutationObserver' in window) {
      var lastMsg = '';
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          var b = m.target;
          if (!b.classList || !b.classList.contains('isd-pdp-card__add')) return;
          var msg = '';
          var nameEl = b.closest('[data-isd-pdp-card]') && b.closest('[data-isd-pdp-card]').querySelector('.isd-pdp-card__name');
          var name = nameEl ? nameEl.textContent.trim() : '';
          if (b.classList.contains('is-added')) msg = TEXT.added + (name ? ': ' + name : '');
          else if (b.classList.contains('is-error')) msg = TEXT.error;
          if (msg && msg !== lastMsg) { lastMsg = msg; live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 40); setTimeout(function () { lastMsg = ''; }, 1500); }
        });
      }).observe(track, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  /* ---------- Box add-ons: collection catalogue, locked until the real cart holds a box ---------- */
  function initBoxAddons(box) {
    var pillsEl = box.querySelector('[data-isd-addon-pills]');
    var grid = box.querySelector('[data-isd-addon-grid]');
    var state = box.querySelector('[data-isd-addon-state]');
    var moreWrap = box.querySelector('[data-isd-addon-more]');
    var moreBtn = moreWrap ? moreWrap.querySelector('button') : null;
    var textEl = box.querySelector('[data-isd-box-text]');
    var markEl = box.querySelector('[data-isd-box-mark]');
    var handle = box.getAttribute('data-collection');
    var boxId = Number(box.getAttribute('data-box-product-id'));
    var categories = (box.getAttribute('data-categories') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean).map(function (c) { var parts = c.split('|').map(function (x) { return x.trim(); }).filter(Boolean); return { label: parts[0], terms: parts }; });
    var pageSize = Number(box.getAttribute('data-page-size') || 8);
    var allLabel = box.getAttribute('data-all-label') || 'Visi';
    var lockedLabel = box.getAttribute('data-locked-label') || TEXT.locked;
    var addLabel = box.getAttribute('data-add-label') || TEXT.add;
    var priceTag = box.getAttribute('data-price-tag') || '';
    var products = null, loaded = false, loading = false, active = '', shown = pageSize, locked = true;

    var ALIAS = { 'olive oil': 'aliejus', oil: 'aliejus', pasta: 'makaronai', coffee: 'kava', sauces: 'padazai', sauce: 'padazai', olives: 'alyvuoges', yeast: 'mieles', balsamic: 'balzaminiai', 'balsamic vinegar': 'balzaminis-actas', delicacies: 'delikatesai', crackers: 'krekeriai', jams: 'dzemai', jam: 'dzemai', snacks: 'uzkandziai', sweets: 'saldumynai', biscuits: 'sausainiai', tomatoes: 'pomidorai', 'tomato puree': 'pomidoru-tyre', 'canned tomatoes': 'konservuoti-pomidorai', 'sun-dried tomatoes': 'dziovinti-pomidorai', flour: 'miltai', 'truffle paste': 'triufeliu-pasta', pate: 'pastetas', spreads: 'uztepeles' };
    function matches(p, cat) {
      if (!cat) return true;
      var terms = (typeof cat === 'string' ? [cat] : cat.terms);
      var type = norm(p.type);
      var tags = p.tags.map(norm);
      return terms.some(function (term) {
        var n = norm(term), h = handleize(term), a = ALIAS[n];
        return type === n || tags.indexOf(n) > -1 || tags.indexOf('box-addon-category:' + h) > -1 || tags.indexOf('kategorija:' + h) > -1 || (a && (type === a || tags.indexOf('box-addon-category:' + a) > -1 || tags.indexOf('kategorija:' + a) > -1 || tags.indexOf(a) > -1));
      });
    }
    function findCategory(label) { return categories.filter(function (c) { return norm(c.label) === norm(label); })[0] || null; }
    function inAnyCategory(p) { return !categories.length || categories.some(function (c) { return matches(p, c); }); }
    /* VISIBILITY RULE (same as the Liquid side): hidden tag, or product type "Dėžutės" whose handle is not an allowed box */
    var hideTags = (box.getAttribute('data-hide-tags') || '').split(',').map(norm).filter(Boolean);
    var boxTypeN = norm(box.getAttribute('data-box-type') || 'Dėžutės');
    var boxHandles = (box.getAttribute('data-box-handles') || '').split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(Boolean);
    function hiddenByRule(p) {
      if (p.tags.some(function (t) { return hideTags.indexOf(norm(t)) > -1; })) return true;
      return norm(p.type) === boxTypeN && boxHandles.indexOf(String(p.handle).toLowerCase()) === -1;
    }
    function usable(p) { return p.id !== boxId && !hiddenByRule(p); }
    function eligible() { return products.filter(function (p) { return usable(p) && inAnyCategory(p); }); }
    function visibleProducts() { var cat = active ? findCategory(active) : null; return eligible().filter(function (p) { return matches(p, cat); }); }
    function render() {
      if (!products) return;
      var list = visibleProducts();
      grid.innerHTML = list.slice(0, shown).map(function (p) { return cardHtml(p, { openCart: false, locked: locked, lockedLabel: lockedLabel, addLabel: addLabel, priceTag: priceTag, noCompare: true }); }).join('');
      state.hidden = list.length > 0; state.textContent = TEXT.empty;
      if (moreWrap) { moreWrap.hidden = list.length <= shown; if (moreBtn) moreBtn.textContent = TEXT.more + ' (' + (list.length - shown) + ')'; }
    }
    function renderPills() {
      if (!pillsEl || !products) return;
      var html = '<button type="button" class="isd-pill" data-isd-cat="" aria-pressed="' + (active === '' ? 'true' : 'false') + '">' + esc(allLabel) + '</button>';
      categories.forEach(function (c) {
        if (!products.some(function (p) { return usable(p) && matches(p, c); })) return;
        html += '<button type="button" class="isd-pill" data-isd-cat="' + esc(c.label) + '" aria-pressed="' + (norm(active) === norm(c.label) ? 'true' : 'false') + '">' + esc(c.label) + '</button>';
      });
      pillsEl.innerHTML = html;
    }
    function load() {
      if (loaded || loading || !handle) return;
      loading = true;
      fetch('/collections/' + handle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          products = (d.products || []).map(normalizeProduct);
          loaded = true; loading = false;
          /* the whole section stays hidden while the catalogue has nothing to sell */
          if (!eligible().length) return;
          box.hidden = false;
          renderPills(); render();
        })
        .catch(function () { loading = false; });
    }
    /* the card shows the price of the variant picked in its select */
    box.addEventListener('change', function (e) {
      var sel = e.target.closest ? e.target.closest('.isd-pdp__variant-select select') : null;
      var card = sel && sel.closest('[data-isd-card]');
      if (!card || !products) return;
      var pid = Number(card.getAttribute('data-product-id'));
      var prod = products.filter(function (x) { return x.id === pid; })[0];
      var v = prod && prod.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
      var now = card.querySelector('.isd-card__price-now');
      if (v && now) now.textContent = money(v.price);
    });
    box.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-isd-cat]');
      if (pill) { active = pill.getAttribute('data-isd-cat'); shown = pageSize; box.querySelectorAll('[data-isd-cat]').forEach(function (b) { b.setAttribute('aria-pressed', b === pill ? 'true' : 'false'); }); render(); return; }
      if (moreBtn && e.target === moreBtn) { shown += pageSize; render(); }
    });

    /* Locked <-> unlocked. Only the real cart (ISD.state) decides. */
    function setLocked(v) {
      if (v === locked && box.dataset.isdInit === '1') return;
      locked = v; box.dataset.isdInit = '1';
      box.setAttribute('data-state', v ? 'locked' : 'open');
      if (textEl) textEl.textContent = textEl.getAttribute(v ? 'data-locked' : 'data-unlocked') || '';
      if (markEl) markEl.innerHTML = v ? LOCK_ICON : CHECK_ICON;
      render();
    }
    load();
    box.setAttribute('data-state', 'locked');
    onBoxState(box, function (hasBox) { setLocked(!hasBox); });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-isd-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });
})();

/* Rating summary -> reviews section (smooth scroll with the same Lenis-safe fallback as the hero CTAs) */
(function () {
  if (window.__isdReviewsLinkBound) return;
  window.__isdReviewsLinkBound = true;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-isd-reviews-link]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace('#', '');
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')) || 0;
    var top = Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - off - 8);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, top); return; }
    var start = window.pageYOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    setTimeout(function () { if (Math.abs(window.pageYOffset - start) < 4) window.scrollTo(0, top); }, 260);
  });
})();